import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const instructorEvaluationApi = {
  // 獲取所有教練的評估結果
  getAllInstructorEvaluations: () => api.get('/instructor-evaluations/').then(res => res.data),
  
  // 獲取特定教練的評估結果
  getInstructorEvaluations: (instructorId) => api.get(`/instructor-evaluations/${instructorId}/`).then(res => res.data),
};
